import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

export const useAddAreaViewModel = ({ debouncedSearch }) => {
  const [areaTypes, setAreaTypes] = useState([]);

  const stateManager = useComponentState();
  const GET_AREA_TYPES_UUID = createUUID();

  const getAreaTypes = () => {
    stateManager.abort(GET_AREA_TYPES_UUID);
    stateManager.run(async () => {
      const response = await homeService.areaTypes.getAll({
        sort: "name",
        filters: [{ name: { contains: debouncedSearch } }],
      });
      if (response.status === HTTP_STATUSES.OK) {
        setAreaTypes(response.data);
      }
    }, GET_AREA_TYPES_UUID);
  };

  return {
    areaTypes,
    getAreaTypes,
  };
};
